import styled from '@emotion/styled';
import { Button, Colors } from '@zapier/design-system';
import { mediaQueries } from 'components/mediaQueries';
import { peach } from 'constants/blogColors';
import { SingleArticleQuery_articleCollection_items_body_links_entries_block_InArticleCtaContainer_fallbackCta } from 'graphql/__generated__/operations/SingleArticleQuery';
import { useRouter } from 'next/router';
import { useTrackEvent } from 'tracking/useTrackEvent';
import { Headline } from './CTACommonStyles';

type props = {
  inArticleCTA: SingleArticleQuery_articleCollection_items_body_links_entries_block_InArticleCtaContainer_fallbackCta;
};
export const HowItWorksCTA = ({ inArticleCTA }: props) => {
  const {
    headline,
    buttonText,
    buttonUrl,
    subhead,
    isSubheadBold,
  } = inArticleCTA;
  const trackEvent = useTrackEvent();
  const router = useRouter();

  return (
    <CTAWrapper>
      <Headline>{headline}</Headline>
      <Subhead isBold={isSubheadBold === 'Yes'}>{subhead}</Subhead>
      <ButtonWrapper>
        <Button
          target="_blank"
          href={buttonUrl!}
          color="black"
          onClick={() =>
            trackEvent('call_to_action', {
              path: window.location.pathname,
              from_path: document.referrer,
              cta_name: 'how_it_works',
              cta_raw_text: headline!,
              cta_location: router.asPath,
              cta_goal: 'get_more_information',
              link_destination: buttonUrl!,
            })
          }
        >
          {buttonText}
        </Button>
      </ButtonWrapper>
    </CTAWrapper>
  );
};

const CTAWrapper = styled.article`
  border-radius: 5px;
  background-color: ${peach};
  text-align: center;
  padding: 30px 20px;
  margin-left: 0;

  ${mediaQueries.tablet} {
    float: right;
    width: 50%;
    padding: 50px 30px 40px 30px;
    margin-left: 20px;
  }
`;

const ButtonWrapper = styled.div`
  margin-top: 20px;

  /**
   * We had to resort to this as we're already overriding the span:hover behavior
   here https://github.com/zapier/blog/blob/f21ad3a031a3f701201b03449ed0f39d0087a89b/src/components/Link/Link.tsx#L75-L78
   */
  a:hover,
  a:focus {
    span {
      color: ${Colors.white};
    }
  }
`;

const Subhead = styled.div`
  margin-top: 10px;
  font-size: 16px;
  color: ${Colors.grey900};
  font-weight: ${({ isBold }: { isBold: boolean }) =>
    isBold ? '800' : 'normal'};
  ${mediaQueries.tablet} {
    font-size: 23px;
  }
`;
